module.exports = "/_next/static/images/os_mac-ca4e5e000ae439e9e8d8b055e279312c.svg";